var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 4.5C18.6047 4.5 4.5 18.6047 4.5 36C4.5 53.3953 18.6047 67.5 36 67.5C53.3953 67.5 67.5 53.3953 67.5 36C67.5 18.6047 53.3953 4.5 36 4.5ZM38.25 51.1875C38.25 51.4969 37.9969 51.75 37.6875 51.75H34.3125C34.0031 51.75 33.75 51.4969 33.75 51.1875V32.0625C33.75 31.7531 34.0031 31.5 34.3125 31.5H37.6875C37.9969 31.5 38.25 31.7531 38.25 32.0625V51.1875ZM36 27C35.1168 26.982 34.2759 26.6185 33.6577 25.9875C33.0395 25.3565 32.6932 24.5084 32.6932 23.625C32.6932 22.7416 33.0395 21.8935 33.6577 21.2625C34.2759 20.6315 35.1168 20.268 36 20.25C36.8832 20.268 37.7241 20.6315 38.3423 21.2625C38.9605 21.8935 39.3068 22.7416 39.3068 23.625C39.3068 24.5084 38.9605 25.3565 38.3423 25.9875C37.7241 26.6185 36.8832 26.982 36 27Z",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.fc865490caf7d37beffc95cf92433c9c.svg";
export { ForwardRef as ReactComponent };